import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as YUP from "yup";
import { Alert, AlertColor, Box, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { ALL_SKILLS, SKILLS } from "../../../services/endpoints";
import axiosInstance from "../../../services/axios-instance";
import { SkillsInterface } from "../../../interface/skillsInterface";
import SkillsTable from "../../elements/SkillsTable";

const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

const cellNames = {
    cellOne: "Skill",
    cellTwo: "Edit skill name",
    cellTree: "Edit skill",
    cellFour: "Remove skill",
};

const validationSchema = YUP.object({
    name: YUP.string().required("Name is required"),
});

const AdminSkillsScreen = () => {
    const [allSkills, setAllSkills] = useState<SkillsInterface[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState<AlertColor | undefined>(
        "success"
    );

    const handleSubmit = async (values: { name: string }) => {
        setIsLoading(true);

        try {
            const responseCreteNewSkill = await axiosInstance.post(SKILLS, {
                name: values.name,
            });
            const newSkill = responseCreteNewSkill.data.skill;
            setAllSkills((prevSkills) => [...prevSkills, newSkill]);
            setAlertSeverity("success");
            setAlertMessage("Skill added successfully");
            setIsLoading(false);
        } catch (error: any) {
            setIsLoading(false);
            if (error.response) {
                setAlertSeverity("error");
                setAlertMessage(error.response.data.message);
            }
            console.error(error);
        }
    };

    useEffect(() => {
        async function fetchDataResponseAllSkills() {
            try {
                const responseAllSkills = await axiosInstance.get(ALL_SKILLS);
                setAllSkills(responseAllSkills.data.skills);
            } catch (error) {
                console.error(error);
            }
        }
        fetchDataResponseAllSkills();
    }, []);

    return (
        <Container>
            <h2 style={{ marginBottom: "0.5rem" }}>Add New Skill</h2>
            <Formik
                initialValues={{ name: "" }}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
            >
                {({ errors, touched }) => (
                    <Form noValidate>
                        <Field
                            as={TextField}
                            label="Name"
                            name="name"
                            required
                            className="adminInput"
                            error={touched.name && Boolean(errors.name)}
                        />
                        <ErrorMessage name="name" component="div" />

                        <Box>
                            <Button
                                variant="contained"
                                color="info"
                                type="submit"
                                disabled={isLoading}
                                sx={{ mt: 2, mb: 2 }}
                            >
                                {isLoading ? "Submitting..." : "Submit"}
                            </Button>
                        </Box>
                        {alertMessage && (
                            <Alert
                                severity={alertSeverity}
                                sx={{ width: "100%", mb: 2 }}
                            >
                                {alertMessage}
                            </Alert>
                        )}
                    </Form>
                )}
            </Formik>
            <SkillsTable
                data={allSkills}
                cellNames={cellNames}
                setAllSkills={setAllSkills}
            />
        </Container>
    );
};

export default AdminSkillsScreen;
